"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgMobileWifi(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("rect", { x: 5, y: 3, width: 20, height: 34, rx: 3, stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M15 34a2 2 0 100-4 2 2 0 000 4z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M32.28 3c1.779 1.628 2.912 4.142 2.895 6.976-.018 2.833-1.183 5.361-2.983 7.012", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M29.047 6.232a4.836 4.836 0 011.74 3.778A4.968 4.968 0 0129 13.809", stroke: "currentColor", strokeWidth: 1.975, strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
}
exports.default = SvgMobileWifi;
//# sourceMappingURL=MobileWifi.js.map